import { TOOlTIP_FIELDS } from 'static/tooltipFields';

export const CERTIFICATE_COLUMNS_AG = [
  {
    dataType: 'string',
    headerName: 'Certificate Level',
    fieldName: 'level',
    fieldNameCamelCase: 'level',
    resizable: true,
    flex: 1,
  },
  {
    dataType: 'string',
    headerName: 'Certificate Name',
    fieldName: 'certificateName',
    fieldNameCamelCase: 'certificateName',
    resizable: true,
    flex: 1,
  },
  {
    dataType: 'string',
    headerName: 'Certificate Type',
    fieldName: 'type',
    fieldNameCamelCase: 'type',
    resizable: true,
    flex: 1,
  },
  {
    dataType: 'string',
    headerName: 'Certificate Body',
    fieldName: 'certificateBody',
    fieldNameCamelCase: 'certificateBody',
    resizable: true,
    flex: 1,
  },
  {
    dataType: 'string',
    headerName: 'Status',
    fieldName: 'status',
    fieldNameCamelCase: 'status',
    resizable: true,
    flex: 1,
  },
];

export const CERTIFICATE_STATUS = [
  { value: 'Active', displayName: 'Active' },
  { value: 'Archived', displayName: 'Archived' },
];

export const TypesConvertPDFPreview = ['ppt', 'pptx', 'doc', 'docx', 'pdf'];

export const CERTIFICATE_COLUMNS = [
  {
    title: 'Certificate Level',
    fieldName: 'level',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.certificateLevel.fieldPath,
  },
  {
    title: 'Certificate Name',
    fieldName: 'certificateName',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.certificateName.fieldPath,
  },
  {
    title: 'Certificate Type',
    fieldName: 'type',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.certificateType.fieldPath,
  },
  {
    title: 'Certificate Body',
    fieldName: 'certificateBody',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.certificateBody.fieldPath,
  },
  {
    title: 'Status',
    fieldName: 'status',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.certificateStatus.fieldPath,
  },
];

export const SUPPORT_TYPES = [
  'jpeg',
  'png',
  'jpg',
  'tiff',
  'tif',
  'txt',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'bmp',
  'gif',
  'csv',
];
